module.exports = __webpack_public_path__ + "static/media/landelijk.4808493a.jpg";